<template>
  <div class="large-12 columns">
    <div class="transactions">
      <h1 class="form-section__title">
        {{ $t('ADVERTISEMENT.FINANCE.TRANSACTIONS') }}
      </h1>
      <CardApiError
        v-if="apiError"
        :error-text="$t('ADVERTISEMENT.TRANSACTIONS.API_ERROR')"
        @retry="getTransactions"
      />

      <TransactionsTable
        v-else
        :transactions="transactions"
        :is-loading="isRequestingTransactions"
      />
    </div>
    <DownloadInvoiceFactorModal
      v-model="showDownloadInvoiceFactorModal"
      :invoice-id="invoiceId"
    />
  </div>
</template>

<script>
import { Advertisement } from '@/api/api';

import DownloadInvoiceFactorModal from './DownloadInvoiceFactorModal';
import TransactionsTable from './TransactionsTable';

import modal from '@/mixins/modal';
import form from '@/mixins/form';
import layout from '@/mixins/layout';
import lang from '@/mixins/lang';

import CardApiError from '@@/common/CardApiError';

import {
  AD_FINANCE_BUDGET_INCREASE_STATE,
  STATE,
} from '@/constants/gtm-events';

export default {
  components: {
    CardApiError,
    TransactionsTable,
    DownloadInvoiceFactorModal,
  },
  mixins: [modal, form, layout, lang],

  props: {
    state: {
      type: String,
      default: '',
    },
    invoiceId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      apiError: false,
      isRequestingTransactions: true,
      transactions: [],
      showDownloadInvoiceFactorModal: false,
    };
  },

  created() {
    if (this.state) {
      if (this.state === 'success') {
        this.$gtm.trackEvent(AD_FINANCE_BUDGET_INCREASE_STATE(STATE.SUCCESS));
      } else {
        this.$gtm.trackEvent(AD_FINANCE_BUDGET_INCREASE_STATE(STATE.FAIL));
      }
    }

    this.getTransactions();
  },
  mounted() {
    if (this.invoiceId) {
      this.showDownloadInvoiceFactorModal = true;
    }
  },

  methods: {
    getTransactions() {
      this.isRequestingTransactions = true;
      return Advertisement.getTransactions()
        .then(({ body: transactions = [] }) => {
          this.transactions = [...transactions];
          this.isRequestingTransactions = false;
          this.apiError = false;
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
          this.apiError = true;
        })
        .then(() => {
          this.isRequestingTransactions = false;
        });
    },
  },
};
</script>
